import { ReactNode } from 'react';
import { cn } from '@prenuvo/halo';

interface RequiredProps {
  children: ReactNode;
  className?: { indicator?: string; root?: string };
  isRequired?: boolean;
  variant?: 'absolute';
}

export function Required({ children, className, isRequired, variant }: RequiredProps) {
  return (
    <span
      className={cn(
        'inline-flex flex-row items-baseline',
        {
          'relative w-fit': variant === 'absolute',
        },
        className?.root,
      )}
    >
      {children}
      {isRequired && (
        <span
          className={cn(
            "ml-1 shrink-0 text-red-500 after:content-['*'] dark:text-red-500",
            {
              'absolute -top-1 -right-2.5': variant === 'absolute',
            },
            className?.indicator,
          )}
        />
      )}
    </span>
  );
}
